import {ChangeDetectorRef, Component, ElementRef, forwardRef, Input, ViewChild} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FUIDeprecatedTextControlComponent),
    multi: true
};

@Component({
    selector: "fui-deprecated-text-control",
    templateUrl: "./deprecated-text-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR],
    styleUrls: ["./deprecated-text-control.component.scss"]
})
export class FUIDeprecatedTextControlComponent extends FUIAbstractControl {
    @Input() public type: string = "text";
    @Input() public isLoading: boolean;
    @Input() public icon: string;

    @ViewChild('input') inputRef: ElementRef;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    override click() {
        this.inputRef.nativeElement.click()
    }

    setFocus() {
        this.inputRef.nativeElement.focus()
    }
}
